import { Component, Input, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { langLink } from '../../../services/i18n-live';

/** One package card. Colours come from the i18n data as they are (official card schemes). */
export interface PackageCardVM {
  type: string;
  goal?: string;
  lines: string[];
  price: string;
  icon: string;
  description?: string;
  bgColor: string;
  fontColor: string;
}

/** Card scheme, from the card's own background: lets styles follow the card, not its position. */
export type PackageTone = 'black' | 'purple' | 'white';

/**
 * The package cards shared by home #services and the Services page: up to three cards per row
 * that rise in on scroll, tilt toward a fine pointer and roll their prices in.
 * Styles live in assets/css/motion/packages.css (shared by both pages).
 */
@Component({
  selector: 'app-package-grid',
  templateUrl: './package-grid.component.html',
  styleUrl: './package-grid.component.css',
})
export class PackageGridComponent {
  private readonly translate = inject(TranslateService);
  @Input() packages: PackageCardVM[] = [];
  @Input() variant: 'home' | 'services' = 'home';

  trackByIndex(index: number): number {
    return index;
  }

  tone(card: PackageCardVM): PackageTone {
    const bg = card.bgColor.trim().toLowerCase();
    return bg === 'black' || bg === '#000' || bg === '#000000' ? 'black' : bg === 'white' || bg === '#fff' || bg === '#ffffff' ? 'white' : 'purple';
  }

  detailsLink(): string {
    return langLink(this.translate, '/services');
  }
}
